import { combineReducers } from 'redux';
import localForage from 'localforage';
import { userApi } from '@ports/internal-services/user/userApi';
import { subscriptionApi } from '@ports/internal-services/subscription/subscriptionApi';
import { userDetailsApi } from '@ports/internal-services/userDetails/userDetailsApi';
import { notificationSettingsApi } from '@ports/internal-services/notificationSettings/notificationSettingsApi';
import { paymentApi } from '@ports/internal-services/payment/paymentApi';
import { userAddressApi } from '@ports/internal-services/userAddress/userAddressApi';
import { utilityConfigurationApi } from '@ports/internal-services/utilityConfiguration/utilityConfigurationApi';
import { assetApi } from '@ports/internal-services/asset/assetApi';
import { folderApi } from '@ports/internal-services/folder/folderApi';
import { commentApi } from '@ports/internal-services/comment/commentApi';
import { diaryApi } from '@ports/internal-services/diary/diaryApi';
import { commentLikesApi } from '@ports/internal-services/commentLikes/commentLikesApi';
import { likesApi } from '@ports/internal-services/likes/likesApi';
import { favoritesApi } from '@ports/internal-services/favorites/favoritesApi';
import { privateApi } from '@ports/internal-services/private/privateApi';
import { photoTagApi } from '@ports/internal-services/photoTag/photoTagApi';
import { recipeApi } from '@ports/internal-services/recipe/recipeApi';
import { momentsApi } from '@ports/internal-services/moments/momentsApi';
import { momentDiaryApi } from '@ports/internal-services/momentDiary/momentDiaryApi';
import { trashApi } from '@ports/internal-services/trash/trashApi';
import { memoriesApi } from '@ports/internal-services/memories/memoriesApi';
import { peopleApi } from '@ports/internal-services/people/peopleApi';
import { shareApi } from '@ports/internal-services/share/shareApi';
import { userRoleApi } from '@ports/internal-services/userRole/userRoleApi';
import { inviteApi } from '@ports/internal-services/invite/inviteApi';
import { groupApi } from '@ports/internal-services/group/groupApi';
import { authStateSlice } from './authStateSlice';
import { sessionStateSlice } from './sessionStateSlice';
import { subscriptionStateSlice } from './subscriptionStateSlice';
import { userStateSlice } from './userStateSlice';
import { addressStateSlice } from './billingAddressStateSlice';
import { alertSlice } from './AlertStateSlice';
import { manualLoadingStateSlice } from './manualLoadingStateSlice';
import { commonStateSlice } from './commonStateSlice';
import { folderStateSlice } from './folderStateSlice';
import { filterStateSlice } from './filtersStateSlice';
import { favoriteViewSlice } from './favoriteViewSlice';

const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  keyPrefix: 'mykinships-persist-'
};

const rootReducer = combineReducers({
  [authStateSlice.name]: authStateSlice.reducer,
  [sessionStateSlice.name]: sessionStateSlice.reducer,
  [subscriptionStateSlice.name]: subscriptionStateSlice.reducer,
  [userStateSlice.name]: userStateSlice.reducer,
  [addressStateSlice.name]: addressStateSlice.reducer,
  [alertSlice.name]: alertSlice.reducer,
  [manualLoadingStateSlice.name]: manualLoadingStateSlice.reducer,
  [commonStateSlice.name]: commonStateSlice.reducer,
  [folderStateSlice.name]: folderStateSlice.reducer,
  [filterStateSlice.name]: filterStateSlice.reducer,
  [favoriteViewSlice.name]: favoriteViewSlice.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  [notificationSettingsApi.reducerPath]: notificationSettingsApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [userAddressApi.reducerPath]: userAddressApi.reducer,
  [utilityConfigurationApi.reducerPath]: utilityConfigurationApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [diaryApi.reducerPath]: diaryApi.reducer,
  [commentLikesApi.reducerPath]: commentLikesApi.reducer,
  [likesApi.reducerPath]: likesApi.reducer,
  [assetApi.reducerPath]: assetApi.reducer,
  [folderApi.reducerPath]: folderApi.reducer,
  [favoritesApi.reducerPath]: favoritesApi.reducer,
  [privateApi.reducerPath]: privateApi.reducer,
  [photoTagApi.reducerPath]: photoTagApi.reducer,
  [peopleApi.reducerPath]: peopleApi.reducer,
  [recipeApi.reducerPath]: recipeApi.reducer,
  [momentsApi.reducerPath]: momentsApi.reducer,
  [momentDiaryApi.reducerPath]: momentDiaryApi.reducer,
  [trashApi.reducerPath]: trashApi.reducer,
  [shareApi.reducerPath]: shareApi.reducer,
  [memoriesApi.reducerPath]: memoriesApi.reducer,
  [userRoleApi.reducerPath]: userRoleApi.reducer,
  [inviteApi.reducerPath]: inviteApi.reducer,
  [groupApi.reducerPath]: groupApi.reducer
});

export { rootPersistConfig, rootReducer };
